// File: frontend/src/components/common/WebStoriesWidget.js

import React, { useEffect, useState, useRef } from 'react';
import { fetchWebStories } from '../../services/api';
import { FaBolt, FaPlay } from 'react-icons/fa'; 
import './WebStoriesWidget.css';

// ✅ HELPER: Cloudinary ULTRA High Quality Optimization
// FIX: Resolution w_500 kiya taaki image blur na ho
const getHighQualityUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    if (url.includes('cloudinary.com') && url.includes('/upload/')) {
        // w_500, h_889 ensures sharp images even on high-DPI screens
        return url.replace('/upload/', '/upload/w_500,h_889,c_fill,q_auto:best,f_auto/');
    }
    return url;
};

// ✅ SUB-COMPONENT: Story Card with Auto-Slide
const StoryPreviewCard = ({ story }) => {
    // Images array: Cover + First 3 Slides
    const previewImages = [
        story.coverImage, 
        ...(story.pages ? story.pages.slice(0, 3).map(p => p.image) : [])
    ].filter(Boolean);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (previewImages.length <= 1) return;

        const resetTimeout = () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
        resetTimeout();

        // Change slide every 3 seconds
        timeoutRef.current = setTimeout(() => {
            setCurrentImageIndex((prevIndex) => 
                prevIndex === previewImages.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);

        return () => resetTimeout();
    }, [currentImageIndex, previewImages.length]);

    // Backend URL
    const storyUrl = `https://indiajagran-backend.onrender.com/web-stories/${story.slug}`;

    return (
        <a 
            href={storyUrl}
            target="_blank" 
            rel="noopener noreferrer"
            className="ws-card-modern"
        >
            <div className="ws-image-container">
                {previewImages.map((imgUrl, index) => (
                    <img 
                        key={index}
                        src={getHighQualityUrl(imgUrl)} 
                        alt={story.title}
                        className={`ws-preview-image ${index === currentImageIndex ? 'active' : ''}`}
                        loading={index === 0 ? "eager" : "lazy"} 
                    />
                ))}
                
                {/* Progress Bar */}
                 <div className="ws-progress-bar">
                    {previewImages.map((_, idx) => (
                        <div key={idx} className={`progress-dot ${idx === currentImageIndex ? 'active' : ''}`}></div>
                    ))}
                </div>

                {/* Gradient Overlay */}
                <div className="ws-overlay-gradient"></div>

                {/* Icon Badge */}
                 <div className="ws-icon-badge"><FaPlay style={{ marginLeft: '2px', fontSize: '10px' }} /></div>
            </div>
            <div className="ws-content-modern">
                <p className="ws-title-modern">{story.title}</p>
            </div>
        </a>
    );
};

// ✅ MAIN COMPONENT
const WebStoriesWidget = () => {
    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadStories = async () => {
            try {
                const data = await fetchWebStories();
                // Filter valid stories
                const validStories = data.filter(s => s.coverImage && s.pages && s.pages.length > 0);
                setStories(validStories);
                setLoading(false);
            } catch (error) {
                console.error("Failed to load web stories");
                setLoading(false);
            }
        };
        loadStories();
    }, []);

    if (loading) return null;
    if (!stories || stories.length === 0) return null;

    return (
        <div className="web-stories-container-modern">
            <div className="ws-header-modern">
                <h3><FaBolt style={{color: '#FFD700'}}/> Visual Stories</h3>
            </div>
            
            <div className="ws-scroll-area-modern">
                {stories.map((story) => (
                   <StoryPreviewCard key={story._id} story={story} />
                ))}
            </div>
        </div>
    );
};

export default WebStoriesWidget;